import { DeclinedReason} from './declined-reason.model'
import { ServiceGroup } from './service-group.model'
import { Appointment } from './appointment.model'

export class ServiceAppointmentDeclinedMpviCode {
  appointmentId: number = null;
  campaignId: string = null;
  classification: number = null;
  declinedReason: number = null;
  embedded?: ServiceAppointmentDeclinedMpviCodeEmbed = null;
  opCode: string = null;
  id: number = null;
  printFlag: boolean = null;
  sequence: string = null;

  constructor(obj?: ServiceAppointmentDeclinedMpviCode) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class ServiceAppointmentDeclinedMpviCodeEmbed {
  appointment?: Appointment = null;
  declinedReason?: DeclinedReason = null;
  serviceGroup?: ServiceGroup = null;
}
